import { deleteActuLive } from "../actions/actulives.js";
import { deleteLive } from "../actions/lives.js";
import { deleteMatch } from "../actions/matchs.js";
import { deleteTeam } from "../actions/teams.js";
import { fetchActuLives, fetchLives, fetchMatchs, fetchTeams } from "../api/index.js";

export const getFetchObject = (typeObject) => {
    switch(typeObject){
        case 'team' :
            return {url : fetchTeams, deleteUrl : deleteTeam, label : (team) => {return "l'équipe "+team.name}}
        case 'match' :
            return {url : fetchMatchs, deleteUrl : deleteMatch, label : (match) => {return "le match du "+new Date(match.dateTime).toLocaleDateString("fr-FR")}}
        case 'actulive' :
            return {url : fetchActuLives, deleteUrl : deleteActuLive, label : (actu) => {return "l'actu "+actu.name}}
        case 'live' :
            return {url : fetchLives, deleteUrl : deleteLive, label : (live) => {return "le live "+live.name}}
        default :
            return () => console.warn('Fetch Object Unknown ', typeObject)
    }

}